module.exports = __webpack_public_path__ + "img/address.a06d98da.jpg";